import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var FontLookup = /** @class */ (function (_super) {
    __extends(FontLookup, _super);
    function FontLookup() {
        return _super.call(this) || this;
    }
    FontLookup.forceNativeConstructor = true;
    FontLookup.forceNativeMethods = true;
    // JS -> AS Bindings
    FontLookup.DEVICE = 'device';
    FontLookup.EMBEDDED_CFF = 'embeddedCFF';
    return FontLookup;
}(ASObject));
export { FontLookup };
